"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContainer = exports.StyledCircle = exports.ButterflyPath = exports.CircleSvg = exports.rotateCircle = exports.animateCircle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const uuidCircleSvg = 'c452ae5f-fa9b-4411-bdd5-cfa2ffedcc78';
exports.animateCircle = (0, styled_components_1.keyframes) `
  0% {
    stroke-dashoffset: 200px;
  }
  50% {
    stroke-dashoffset: 76px;
  }
  100% {
    stroke-dashoffset: 200px;
  }
`;
exports.rotateCircle = (0, styled_components_1.keyframes) `
  0% {
     transform: rotate(-90deg);
  }
  50% {
     transform: rotate(90deg);
  }
  100% {
    transform: rotate(630deg);
  }
`;
exports.CircleSvg = styled_components_1.default.svg.withConfig({
    componentId: `LoaderCircle-${uuidCircleSvg}`,
}) `
  position: absolute;
  top: 0;
  left: 0;
  animation: ${exports.rotateCircle} 2000ms linear infinite;
`;
exports.ButterflyPath = styled_components_1.default.path `
  transform-origin: 50% 50%;
  fill: ${({ theme }) => theme.colors.main.base};

  ${({ type, theme }) => type === 'secondary' &&
    (0, styled_components_1.css) `
      fill: ${theme.colors.text.body};
    `}

  ${({ type, theme }) => type === 'alt' &&
    (0, styled_components_1.css) `
      fill: ${theme.colors.gray.s300};
    `}
`;
exports.StyledCircle = styled_components_1.default.circle `
  animation: ${exports.animateCircle} 2000ms linear infinite;
  fill: transparent;

  stroke-width: 2;
  stroke-dasharray: 200px;
  stroke-dashoffset: 100px;
  stroke-linecap: round;

  transform-origin: 50% 50%;

  stroke: ${({ theme }) => theme.colors.main.base};

  ${({ type, theme }) => type === 'secondary' &&
    (0, styled_components_1.css) `
      stroke: ${theme.colors.gray.s800};
    `}

  ${({ type, theme }) => type === 'alt' &&
    (0, styled_components_1.css) `
      stroke: ${theme.colors.gray.s300};
    `}
`;
exports.LoaderContainer = styled_components_1.default.div `
  position: relative;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
